import { useEffect, useState } from 'react';
import { api } from '../lib/api';
import { confirm, haptic } from '../lib/telegram';

interface Props { onBack: () => void; }

export default function Categories({ onBack }: Props) {
  const [items, setItems] = useState<string[]>([]);
  const [isDefault, setIsDefault] = useState(false);
  const [newName, setNewName] = useState('');
  const [err, setErr] = useState<string | null>(null);
  const [busy, setBusy] = useState(false);
  const [loading, setLoading] = useState(true);

  async function load() {
    setErr(null);
    try {
      const r = await api.listCategories();
      setItems(r.categories);
      setIsDefault(r.is_default);
    } catch (e) {
      setErr(e instanceof Error ? e.message : 'failed to load');
    } finally {
      setLoading(false);
    }
  }
  useEffect(() => { load(); }, []);

  async function add(e: React.FormEvent) {
    e.preventDefault();
    const name = newName.trim();
    if (!name) return;
    setBusy(true);
    try {
      await api.addCategory(name);
      setNewName('');
      haptic('success');
      await load();
    } catch (e) {
      haptic('error');
      setErr(e instanceof Error ? e.message : 'failed');
    } finally { setBusy(false); }
  }

  async function remove(name: string) {
    if (!(await confirm(`Remove "${name}"? Existing entries won't change.`))) return;
    setBusy(true);
    try {
      await api.removeCategory(name);
      haptic('success');
      await load();
    } catch (e) {
      haptic('error');
      setErr(e instanceof Error ? e.message : 'failed');
    } finally { setBusy(false); }
  }

  return (
    <>
      <div className="header">
        <button className="back" onClick={onBack}>← Back</button>
        <h1>Categories</h1>
      </div>
      {err && <div className="error">{err}</div>}

      <form className="card" onSubmit={add}>
        <label className="label" style={{ marginTop: 0 }}>Add a category</label>
        <div style={{ display: 'flex', gap: 8 }}>
          <input className="input" value={newName} onChange={(e) => setNewName(e.target.value)} placeholder="e.g. Eating out" maxLength={40} />
          <button type="submit" className="btn" style={{ width: 'auto', padding: '12px 18px' }} disabled={busy || !newName.trim()}>Add</button>
        </div>
      </form>

      <div className="card">
        <div className="muted small" style={{ marginBottom: 8 }}>
          {isDefault ? 'Using built-in defaults. Add one to start customizing.' : 'Your categories'}
        </div>
        {loading ? <div className="muted">Loading…</div> : items.length === 0 ? (
          <div className="empty">No categories.</div>
        ) : items.map((c) => (
          <div key={c} className="row">
            <span>{c}</span>
            {!isDefault && (
              <button className="btn-danger" style={{ background: 'transparent', border: 'none', padding: '4px 8px', cursor: 'pointer' }} onClick={() => remove(c)}>Remove</button>
            )}
          </div>
        ))}
      </div>
    </>
  );
}
